<template>
  <div v-outside-click="clickOutside" class="iconselect">
    <div class="iconselect__title" @click="iconClicked">
      <div>
        <label class="iconselect__icon-label">{{ $t("views.icons.icon") }}</label>
        <div>
          <custom-icon :class-name="`${icon ? icon : selectedIcon.icon}`" />
          <span>{{ icon ? iconTitle : selectedIcon.title }}</span>
        </div>
      </div>
      <custom-icon class-name="icon-chevron-down-2" />
    </div>
    <div
      v-if="showList"
      class="iconselect__modal"
      :style="{ left: position.x, bottom: position.y, width: `${width}px` }"
    >
      <div v-for="item in iconsArray" :key="item.id" class="iconselect__modal-item" @click="setActiveItem(item)">
        <custom-icon :class-name="`${item.icon}`" />
        <span>{{ item.title }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import CustomIcon from "../../commons/CustomIcon.vue";
export default {
  components: { CustomIcon },
  props: ["icon"],
  emits: ["icon-selected"],
  data() {
    return {
      iconsArray: [
        {
          title: this.$t("views.icons.bag"),
          icon: "icon-bag-suitcase",
        },
        {
          title: this.$t("views.icons.chart"),
          icon: "icon-chart-bar",
        },
        {
          title: this.$t("views.icons.chair"),
          icon: "icon-chair-school",
        },
        {
          title: this.$t("views.icons.ruler"),
          icon: "icon-ruler",
        },
        {
          title: this.$t("views.icons.document"),
          icon: "icon-file-document-outline",
        },
        {
          title: this.$t("views.icons.dollar"),
          icon: "icon-currency-usd",
        },
        {
          title: this.$t("views.icons.euro"),
          icon: "icon-currency-eur",
        },
        {
          title: this.$t("views.icons.filter"),
          icon: "icon-Filter-2",
        },
        {
          title: this.$t("views.icons.airPlane"),
          icon: "icon-airplane",
        },
        {
          title: this.$t("views.icons.car"),
          icon: "icon-car",
        },
        {
          title: this.$t("views.icons.toolBox"),
          icon: "icon-toolbox-outline",
        },
        {
          title: this.$t("views.icons.flag"),
          icon: "icon-flag-outline",
        },
        {
          title: this.$t("views.icons.home"),
          icon: "icon-home",
        },
      ],
      selectedIcon: {
        id: 2,
        title: this.$t("views.icons.bag"),
        icon: "icon-bag-suitcase",
      },
      showList: false,
      position: { x: null, y: null },
      width: 0,
    };
  },
  computed: {
    iconTitle() {
      const matchedIcon = this.iconsArray.find((icon) => icon.icon === this.icon);
      return matchedIcon ? matchedIcon.title : ""; // Return the title if icon is found, otherwise return an empty string
    },
  },
  methods: {
    clickOutside() {
      this.showList = false;
    },
    iconClicked(e) {
      const boundElement = e.target.closest(".iconselect__title").getBoundingClientRect();
      this.width = boundElement.width;

      this.position = { x: e.clientX, y: e.clientY };
      this.showList = !this.showList;
    },
    setActiveItem(item) {
      this.selectedIcon = item;
      this.showList = false;
      this.$emit("icon-selected", item.icon);
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../../assets/styles/variables";
.iconselect {
  position: relative;
  &__icon-label {
    font-size: 12px;
  }
  &__title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    padding: 0.4rem 0;
    &:hover {
      background-color: @kk-color-background;
    }
  }
  &__modal {
    position: fixed;
    padding: 0.4rem;
    z-index: 1000;
    background-color: white;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    box-shadow: @kk-primary-box-shadow;
    &-item {
      padding: 0.4rem;
      &:hover {
        background-color: @kk-color-background;
        cursor: pointer;
      }
    }
  }
}
</style>
